import { ComponentRef, PropsWithChildren, Ref } from 'react'

import { connect, mapProps, mapReadPretty } from '@formily/react'
import { Select as AntdSelect, SelectProps } from 'antd'
import { BaseOptionType, DefaultOptionType } from 'antd/es/select'

export const Select = connect(
  AntdSelect,
  mapReadPretty(AntdSelect, {
    disabled: true
  }),
  mapProps({ dataSource: 'options' }, props => {
    return {
      allowClear: true,
      ...props
    }
  })
) as <
  ValueType,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType
>(
  props: PropsWithChildren<SelectProps<ValueType, OptionType>> & {
    ref?: Ref<ComponentRef<typeof AntdSelect>>
  }
) => React.JSX.Element
